__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sabai-elt";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/api", "6.1.9", () => (Promise.all([__webpack_require__.e(147), __webpack_require__.e(106), __webpack_require__.e(951), __webpack_require__.e(518), __webpack_require__.e(427)]).then(() => (() => (__webpack_require__(4951))))));
			register("@aws-amplify/auth", "6.9.0", () => (Promise.all([__webpack_require__.e(147), __webpack_require__.e(245), __webpack_require__.e(81), __webpack_require__.e(518), __webpack_require__.e(427)]).then(() => (() => (__webpack_require__(5308))))));
			register("@aws-amplify/core", "6.8.0", () => (Promise.all([__webpack_require__.e(147), __webpack_require__.e(106), __webpack_require__.e(423), __webpack_require__.e(411), __webpack_require__.e(518)]).then(() => (() => (__webpack_require__(5411))))));
			register("@sabaicode-dev/ui-component", "0.0.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(700), __webpack_require__.e(641), __webpack_require__.e(163), __webpack_require__.e(997)]).then(() => (() => (__webpack_require__(7997))))));
			register("aws-amplify", "6.11.0", () => (Promise.all([__webpack_require__.e(147), __webpack_require__.e(423), __webpack_require__.e(245), __webpack_require__.e(427), __webpack_require__.e(266)]).then(() => (() => (__webpack_require__(9266))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(641)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.28.1", () => (Promise.all([__webpack_require__.e(955), __webpack_require__.e(641), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "18.3.1", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
			register("tslib", "2.8.1", () => (__webpack_require__.e(117).then(() => (() => (__webpack_require__(4117))))));
			initExternal(8878);
			initExternal(7406);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};